export default __webpack_public_path__ + "static/media/iModX.1ac7d5ac.svg";